import { render, staticRenderFns } from "./HostName.vue?vue&type=template&id=2f5039f8&scoped=true&"
import script from "./HostName.vue?vue&type=script&lang=js&"
export * from "./HostName.vue?vue&type=script&lang=js&"
import style0 from "../ThemeSettingsChildren.css?vue&type=style&index=0&id=2f5039f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5039f8",
  null
  
)

export default component.exports